
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { TreeNode } from '../../../../core/interfaces/tree-node.interface';

@Component({
  selector: 'app-tree-node',
  standalone: true,
  imports: [],
  templateUrl: './tree-node.component.html',
  styleUrl: './tree-node.component.css'
})
export class TreeNodeComponent implements OnInit {

  @Input() node!: TreeNode;
  @Input() level: number = 0;
  
  @Output() nodeSelected = new EventEmitter<TreeNode>();
  @Output() nodeChecked = new EventEmitter<TreeNode>();
  @Output() nodeUnchecked = new EventEmitter<TreeNode>();

  trackByNodeId(index: number, node: TreeNode): string {
    return node.nodeId || `child-${index}`;
  }

  onNodeClick(): void {
    this.nodeSelected.emit(this.node);
  }

  onCheckboxChange(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.node.state.checked = checkbox.checked;
    
    if (checkbox.checked) {
      this.nodeChecked.emit(this.node);
    } else {
      this.nodeUnchecked.emit(this.node);
    }
  }

  toggleExpanded(event: Event): void {
    event.stopPropagation();
    this.node.state.expanded = !this.node.state.expanded;
  }

  ngOnInit() {
  }
}